import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import moment from 'moment'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

// images
import SelectImg from '../../assets/image/radio/ic-select.png'
import UnSelectImg from '../../assets/image/radio/ic-unselect.png'

export default function QuarterlySelectionModal({
  title,
  show,
  handleSubmit,
  handleClose,
}) {
  const [selectedYr, setSelectedYr] = useState(new Date().getFullYear())
  // const [selectedOption, setSelectedOption] = useState('')
  const [start, setStart] = useState(null)
  const [end, setEnd] = useState(null)
  const [selectedIndex, setSelectedIndex] = useState(0)

  useEffect(() => {
    onSetDate(
      selectedIndex,
      quarters[selectedIndex].startDate,
      quarters[selectedIndex].endDate,
    )
  }, [selectedYr]) // selectedYr가 변경될 때마다 실행

  const onChangeDates = (daterange) => {
    // setSelectedOption(daterange)

    setSelectedYr(daterange)

    // const datesArray = daterange.split('~')
    // if (
    //   (datesArray[0] || datesArray[1]) <
    //   moment().subtract(1, 'year').format('YYYY-MM-DD')
    // ) {
    //   alert('최근 1년 동안 받은 주문을 볼 수 있습니다.')
    // } else {
    //   setStart(datesArray[0])
    //   setEnd(datesArray[1])
    // }
  }

  const onSetDate = (flag, sDate, eDate) => {
    let startDate = moment(`${selectedYr}년 ${sDate}`, 'YYYY년 MM월 DD일')
    let endDate = moment(`${selectedYr}년 ${eDate}`, 'YYYY년 MM월 DD일')

    // '오늘 날짜'를 설정
    let today = moment(moment().format('YYYY-MM-DD'))

    // 1년 전과 1년 후의 날짜 계산
    let oneYearAgo = today.clone().subtract(1, 'years')
    let oneYearLater = today.clone().add(1, 'years')

    // startDate와 endDate가 1년 이내 범위에 있는지 확인
    if (
      (startDate.isAfter(oneYearAgo) && endDate.isBefore(oneYearLater)) ||
      oneYearAgo.isBetween(startDate, endDate, null, '[]')
    ) {
      setStart(startDate)
      setEnd(endDate)
      setSelectedIndex(flag)
    } else {
      alert('오늘로부터 1년간의 기간만 조회가 가능합니다.')
      return
    }
  }

  const quarters = [
    { label: '1분기', startDate: '01월 01일', endDate: '03월 31일' },
    { label: '2분기', startDate: '04월 01일', endDate: '06월 30일' },
    { label: '3분기', startDate: '07월 01일', endDate: '09월 30일' },
    { label: '4분기', startDate: '10월 01일', endDate: '12월 31일' },
  ]
  const quarterComponents = quarters.map((quarter, index) => (
    <div className="pb-4" key={index}>
      <div className="form-check-inline-block d-flex align-items-center mt-3 mb-2">
        <RadioCircle
          src={selectedIndex === index ? SelectImg : UnSelectImg}
          onClick={() => onSetDate(index, quarter.startDate, quarter.endDate)} // startDate와 endDate를 전달
        />
        <label className="form-check-label ms-2">
          <span className="d-block text-start">
            <TitleText>{quarter.label}</TitleText>
          </span>
        </label>
      </div>
      <DateRangeTextWrapper>
        <DateRangeText>{`${selectedYr}년 ${quarter.startDate}~${selectedYr}년 ${quarter.endDate}`}</DateRangeText>
      </DateRangeTextWrapper>
    </div>
  ))

  return (
    <Container show={show} onHide={handleClose}>
      <Modal.Header className="px-4" closeButton>
        <ModalTitle className="ms-auto">{title}</ModalTitle>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="d-flex justify-content-center align-items-center pb-2">
          <FormSelect
            aria-label="Default select example"
            onChange={(e) => onChangeDates(e.target.value)}
            value={selectedYr}
          >
            <option value={new Date().getFullYear()}>
              {new Date().getFullYear()}년
            </option>
            <option value={new Date().getFullYear() - 1}>
              {new Date().getFullYear() - 1}년
            </option>
          </FormSelect>
        </div>

        {/* 분기 생성 */}
        {quarterComponents}

        <div className="text-start pt-4">
          <WarningText>- 최근 1년 동안 받은 주문을 볼 수 있습니다</WarningText>
        </div>
      </Modal.Body>
      <ModalFooter>
        <SubmitButton onClick={() => handleSubmit(start, end)}>
          <SubmitButtonTxt>적용</SubmitButtonTxt>
        </SubmitButton>
      </ModalFooter>
    </Container>
  )
}
const Container = styled(Modal)`
  .modal-content {
    width: 360px;
    height: 588px;
    margin: auto;
  }
  .form-check-input:checked {
    background-color: #00a61c !important;
    border-color: #00a61c !important;
  }
  .btn:focus,
  .btn:active {
    outline: none !important;
    box-shadow: none;
  }
  .modal.show .modal-dialog {
    transform: none;
    display: flex;
    justify-content: center;
  }
  .btn-close {
    box-shadow: none;
  }
`
const ModalTitle = styled(Modal.Title)`
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: ${colors.BK};
`
const FormSelect = styled(Form.Select)`
  width: 320px;
  height: 48px;
`
const SubmitButton = styled.button`
  width: 320px;
  height: 50px;
  border-radius: 8px;
  background-color: ${colors.mainG};
`
const SubmitButtonTxt = styled.span`
  width: 24px;
  height: 17px;
  font-family: NotoSansKR;
  font-size: 14px;
  text-align: center;
  color: ${colors.W1};
`

const RadioCircle = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`

// const RadioInput = styled.input`
//   width: 24px;
//   height: 24px;
//   border: solid 1px #d8d8d8;
//   background-color: ${colors.W1};
// `

const TitleText = styled.span`
  width: 32px;
  height: 17px;
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: ${colors.BK};
`
const DateRangeText = styled.span`
  width: 264px;
  height: 17px;
  font-size: 14px;
  text-align: left;
  color: ${colors.G4};
`

const DateRangeTextWrapper = styled.div`
  margin-left: 2rem;
  float: left;
`
const WarningText = styled.span`
  font-size: 12px;
  text-align: left;
  color: ${colors.G4};
`
const ModalFooter = styled(Modal.Footer)`
  justify-content: center;
`
